module.exports = __webpack_public_path__ + "static/media/Background2.19e73107.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Backgrounds/Background2.png
// module id = 253
// module chunks = 0